import React, { useState } from 'react';
//import gql from 'graphql-tag';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import { Formik } from 'formik';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
import UploadPhotoDialog from '../../../components/users/UploadPhotoDialog';
import LoadingSpinner from "../../../common/components/LoadingSpinner/LoadingSpinner";
import { env } from '../../../env';
import { Cookies } from "react-cookie";
import {client} from "../../../settings/apollo";
import RouterPropsWrapper from "../../RouterPropsWrapper";
import { useProfileScore } from '../../../hooks/useProfileScore';
import { useUploadPhoto } from '../../../hooks/useUploadPhoto';
import { useRemovePhoto } from '../../../hooks/useRemovePhoto';
import { useUpdateUser } from '../../../hooks/useUpdateUser';
import { useDeleteUser } from '../../../hooks/useDeleteUser';
import useAppStore from '../../../store/appStore';


const MyProfile = (props) => {
const cookie = new Cookies();
const [uploadDialog, setUploadDialog] = useState(false);
const user = useAppStore((state) => state.user);
const profileScoreQuery = useProfileScore();
const updateUserMutation = useUpdateUser();
const uploadPhotoMutation = useUploadPhoto();
const removePhotoMutation = useRemovePhoto();
const deleteUserMutation = useDeleteUser({
  onError: (error) => {
    Swal.fire(error.message, '', 'error')
  },
  onSuccess: () =>
  {   
    Swal.fire({
      title: 'Account deleted!',
      icon: 'success',
      timer: 1500,
      showConfirmButton: false
    }).then(() => {
      cookie.remove("jwt");
      client.resetStore();   
      props.history.push('/login') 
    });
  }
});

if (profileScoreQuery.loading) return <LoadingSpinner styles={{ paddingTop: 30 }} />;
if (profileScoreQuery.error) return `Error! ${profileScoreQuery.error?.message || 'Profile score error'}`;
if (!user) return <LoadingSpinner styles={{ paddingTop: 30 }} />;

const userData = user.me;
const userGroups = userData.courseGroups?.map((item) => item.name) || [];

// Values from api
const totalUserScore = profileScoreQuery.data?.totalUserScore || 0;
const totalScore = profileScoreQuery.data?.totalScore || 0;

const handleRemovePhoto = async () => {
  try{
    await removePhotoMutation.mutateAsync();
    Swal.fire({
      type: 'success',
      title: 'Photo Removed',
      showConfirmButton: false,
      timer: 1500
    })
  }
  catch(error)
  {
    console.log(error);
    Swal.fire({
      type: 'error',
      title: 'Error',
      text: error?.message || 'Failed to remove photo',
      showConfirmButton: false,
      timer: 1500
    })
  }
}
const handleUpload = async (file) =>  {
  if(file.size > 2097152){
      Swal.fire({
        type: 'error',
        title: 'Error',
        text: "Max Image Size: 2 MB ",
        showConfirmButton: false,
        timer: 2500
      })
    setUploadDialog(false)
    return
  }
  try{  
    await uploadPhotoMutation.mutateAsync({ file });
    Swal.fire({
      type: 'success',
      title: 'Saved',
      showConfirmButton: false,
      timer: 1500
    })
  }
  catch(error)
  {
    Swal.fire({
      type: 'error',
      title: 'Error',
      text: error?.message || 'Failed to upload photo',
      showConfirmButton: false,
      timer: 1500
    })
  }
  setUploadDialog(false)
}
    return (
      <div>
            <Formik
            enableReinitialize={true} 
                    initialValues={{
                      name: userData.name,
                      surname: userData.surname,
                      sigla: userData.sigla,
                      email: userData.email,
                      birthDate: userData.birthDate,
                      country: userData.country,
                      phone: userData.phone,
                      photo: userData.photo,
                      city: userData.city,
                      description: userData.description,
                      linkedin: userData.linkedin,
                      userRole: userData.userRole
                      //courseGroups: userData.courseGroups
                    }}
                    onSubmit={async (values, actions) => {
                      try {
                        actions.setSubmitting(true);
                        const { email, _id, ...rest } = values;
                        const dataToSend = {
                        key: _id, 
                        ...rest
                        };
                        
                        await updateUserMutation.mutateAsync(dataToSend);
                        
                        Swal.fire({
                          type: 'success',
                          title: 'Saved',
                          showConfirmButton: false,
                          timer: 1500
                        });
                      } catch (error) {
                        console.log(error);
                        Swal.fire({
                          type: 'error',
                          title: 'Error',
                          text: error?.message || 'Failed to update profile',
                          showConfirmButton: false,
                          timer: 1500
                        });
                      } finally {
                        actions.setSubmitting(false);
                      }
                    }}
                  >
                    {props => (
                      <form onSubmit={props.handleSubmit}>
                        <div className="row">
                          <div className="col-md-4 d-flex align-items-stretch  flex-wrap">
                            <div className="card">
                              <div className="card-header">
                                <h5 className="card-title">Profile picture</h5>
                              </div>
                              <div className="card-body">
                              <img src={props.values.photo ? `${props.values.photo}?${new Date().getTime()}` : env.PUBLIC_URL + '/assets/img/default-avatar.png'}
                                  alt="Profile gams" className="rounded-circle img-fluid float-left w-50" />
                                <h5>
                                  {/* jpg, png - max dimensions 150x150px, max weight 3 MB */}
                                </h5>

                                <Button className="btn btn-outline-primary" value="upload" onClick={() => setUploadDialog(true)}>Upload your photo</Button>
                                <Button
                                  className="btn btn-outline-primary"
                                  value="upload"
                                  onClick={() => {
                                        Swal.fire({
                                                title: 'Are you sure you want to remove your photo?',
                                                showCancelButton: true,
                                                confirmButtonText: `Yes`,
                                                }).then((result) => {
                                                if (result.value) {
                                                  handleRemovePhoto();
                                                }
                                                })}
                                    }>Remove photo
                                  </Button>

                                <UploadPhotoDialog
                                title="Upload your photo"
                    handleUndo={()=>setUploadDialog(false)}
                    handleClose={()=>setUploadDialog(false)}
                    handleUpload={handleUpload}
                    open={uploadDialog}
                    saveName="Save"
                    button={true}
                    >
                         Select your photo. The optimal size is 360x360px

                      </UploadPhotoDialog>

                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <h5 className="card-title">Profile External Link</h5>
                              </div>
                              <div className="card-body">
                                <h3>
                                  <b>
                                  <div className="form-group bmd-form-group">
                                      <input defaultValue={props.values.linkedin}
                                          type="text"
                                          className="form-control"
                                          name="linkedin"
                                          onChange={props.handleChange}
                                          onBlur={props.handleBlur} />
                                  </div>                                  </b>
                                </h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 d-flex align-items-stretch flex-wrap">
                            <div className="card">
                              <div className="card-header">
                                <h5 className="card-title">Name</h5>
                              </div>
                              <div className="card-body">
                                <h3>
                                  <b>
                                  <div className="form-group bmd-form-group">
                                      <input defaultValue={props.values.name}
                                          type="text"
                                          className="form-control"
                                          name="name"
                                          onChange={props.handleChange}
                                          onBlur={props.handleBlur} />
                                  </div>
                                  </b>
                                </h3>
                              </div>
                            </div>                            
                            <div className="card">
                              <div className="card-header">
                                <h5 className="card-title">Last Name</h5>
                              </div>
                              <div className="card-body">
                                <h3>
                                  <b>
                                  <div className="form-group bmd-form-group">
                                      <input defaultValue={props.values.surname}
                                          type="text"
                                          className="form-control"
                                          name="surname"
                                          onChange={props.handleChange}
                                          onBlur={props.handleBlur} />
                                  </div>                                  </b>
                                </h3>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <h5 className="card-title">Birthdate</h5>
                              </div>
                              <div className="card-body">
                                <h3>
                                  <b>
                                    <div className="form-group bmd-form-group">
                                      <input
                                        defaultValue={moment(props.values.birthDate).format('YYYY-MM-DD')}
                                        name="birthDate"
                                        type="date"
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className="form-control" />
                                    </div>
                                  </b>
                                </h3>
                              </div>
                            </div>

                          </div>
                          <div className="col-md d-flex align-items-stretch">
                            <div className="card">
                              <div className="card-header">
                                <h5 className="card-title">email</h5>
                              </div>
                              <div className="card-body d-flex align-items-center justify-content-center">
                                <h3>
                                  <b>
                                    <div className="form-group bmd-form-group">
                                      {/*<label className="bmd-label-floating">Email</label>
                       <input defaultValue="email" type="text" className="form-control" /> */}
                                      <h5 className="card-title">{props.values.email}</h5>
                                      {/*<Link to={{
                                                                                    pathname: `/password`,
                                                                                }} className="btn btn-outline-primary">
                                                                                    Edit Password
                                                                    </Link>*/}
                                    </div>
                                    {/* <div className="form-group bmd-form-group">
                      <label className="bmd-label-floating">Password</label>
                      <input defaultValue="password" type="password" className="form-control" />
                    </div> */}
                                  </b>
                                </h3>
                              </div>
                            </div>
                          </div>
                          <div className="col-md d-flex align-items-stretch">
                            <div className="card">
                              <div className="card-header">
                                <h4 className="card-title">MY SCORE</h4>
                              </div>
                                    <div className="card-body d-flex align-items-center justify-content-center">
                                      <h2>
                                        <b>
                                          {totalUserScore}/{totalScore}
                                        </b>
                                      </h2>
                                    </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-7 d-flex align-items-stretch">
                            <div className="card">
                              <div className="card-header card-header-warning">
                                <h5 className="card-title">Contacts: </h5>
                              </div>
                              <div className="card-body">
                                <div className="form-group">
                                  <label htmlFor="cityInput" className="bmd-label-floating">City</label>
                                  <input id="cityInput"
                                    type="text"
                                    name="city"
                                    className="form-control"
                                    defaultValue={props.values.city}
                                    autoFocus=""
                                    onChange={props.handleChange}
                                    onBlur={props.handleBlur} />
                                </div>
                                <div className="form-group">
                                  <label className="bmd-label-floating">Country</label>
                                  <input type="text"
                                    name="country"
                                    className="form-control"
                                    defaultValue={props.values.country}
                                    onChange={props.handleChange}
                                    onBlur={props.handleBlur} />
                                </div>
                                <div className="form-group">
                                  <label className="bmd-label-floating">Phone</label>
                                  <input type="text"
                                    name="phone"
                                    className="form-control"
                                    defaultValue={props.values.phone}
                                    onChange={props.handleChange}
                                    onBlur={props.handleBlur} />
                                </div>
                                   </div>
                            </div>
                          </div>
                          <div className="col-md-5">
                          <div className="card">
                              <div className="card-header">
                                <h5 className="card-title">Description</h5>
                              </div>
                              <div className="card-body">
                                <h3>
                                  <b>
                                  <div className="form-group bmd-form-group">
                                      <input                          
                                          type="text"
                                          className="form-control"
                                          name="description"
                                          defaultValue={props.values.description}
                                          onChange={props.handleChange}
                                          onBlur={props.handleBlur}              
                                      />
                                  </div>                                  </b>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        {userData.userRole !== 'student' &&
                        (
                        <div className="row">
                          <div className="col-md-5 d-flex align-items-stretch">
                            <div className="card">
                              <div className="card-header card-header-warning">
                                <h5 className="card-title">School Group</h5>
                              </div>
                              <div className="card-body">
                                {userGroups.map((item, index) =>
                                  <h5 key={index}>
                                    {item}
                                  </h5>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        )}
                        <div className="col-md-12">
                        <Box  style={{  display: "flex", justifyContent: "space-around"}}>

                          <Button className="btn btn-fill btn-rose" type="submit" variant="contained" size="large">
                            <SaveIcon />
                    Save
                  </Button>
                  <Button className="btn  btn-primary" onClick={() => {
                                                            Swal.fire({ 
                                                                    title: 'Are you sure you want to delete your account ?',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: `Yes`,
                                                                    }).then((result) => {
                                                                    if (result.value) {
                                                                      deleteUserMutation.mutateAsync();
                                                                    }
                                                                    })}
                                                            }>Delete Account</Button>
                        </Box>                                    
                        </div>
                      </form>
                    )}
                  </Formik>
      </div>
    )}

export default RouterPropsWrapper(MyProfile);
